import moment from 'moment'

const dateFormat = (date, format = 'DD MMM YYYY') => date && moment(date).format(format)

const isPastDate = (date) => moment(date).isBefore(new Date(), 'day')

export {
  dateFormat, isPastDate
}



// WEBPACK FOOTER //
// ./src/util.js